import type { SupWeb3VaultBalance } from "@/types";
import React, { PropsWithChildren } from "react";

import dictionaryConfig from "@/../config/dictionary.config";
import UiLabelSuperPoolPositionTooltip from "@/components/Ui/Label/SuperPool/PositionTooltip";
import { SupText, SupTooltip } from "@repo/core-ui";
import { SupERC20 } from "@repo/core-ui";
import Link from "next/link";
import { twMerge } from "tailwind-merge";

interface UiLabelSuperPoolCellProps extends PropsWithChildren {
  singlePosition?: SupWeb3VaultBalance;
  isErc20?: boolean;
  hideText?: boolean;
  className?: string;
}

export default function UiLabelSuperPoolPositionCell({ singlePosition, hideText, isErc20 = false, className }: UiLabelSuperPoolCellProps) {
  const hasSuperPool = singlePosition?.is_erc20 || isErc20;

  return (
    hasSuperPool && (
      <Link className={twMerge("inline-flex flex-none", className)} href={dictionaryConfig.superPools.helpArticle} target="_blank">
        <SupTooltip portal unmount placement="right" content={<UiLabelSuperPoolPositionTooltip />} popperElClassName="bg-neutral-50" color="default">
          <div className={twMerge(!hideText && "flex items-center justify-between space-x-0.5 rounded-full border-[.5px] border-success-600 bg-success-50 px-1 py-0.5")}>
            <SupERC20 className={twMerge("text-success-600", hideText ? "h-5 w-5" : "h-3 w-3")} />
            {!hideText && (
              <SupText variant="subtitle2" className="text-success-600">
                ERC-20
              </SupText>
            )}
          </div>
        </SupTooltip>
      </Link>
    )
  );
}
